import React from 'react';
import mixpanel from 'mixpanel-browser';
import {
  HERO_HEADER,
  HERO_SUBHEADER,
  HERO_CTA_TEXT,
  HERO_CTA_LINK,
  HERO_IMAGE_ALT,
} from '../../constants/Careers';

import image from './TeamCollaborationUndraw.png';

import './CareerHero.css';

export const CareerHero = () => {
  const handleHeroCTATrack = () => {
    mixpanel.track('Career Header', {
      action: 'Open Positions',
    });
  };
  return (
    <section className="career-hero">
      <div className="hero-container">
        <div className="hero-text">
          <h1 className="hero-header">{HERO_HEADER}</h1>
          <h5 className="hero-subheader">{HERO_SUBHEADER}</h5>
          <a href={HERO_CTA_LINK} className="hero-cta" onClick={handleHeroCTATrack}>
            {HERO_CTA_TEXT}
          </a>
        </div>
        <div className="hero-image">
          <img src={image} alt={HERO_IMAGE_ALT} />
        </div>
      </div>
    </section>
  );
};
